// extracted by mini-css-extract-plugin
export default {"rows":"vdxBelkbTC0CAAt6rZ4s"};